import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=79a48b21&scoped=true&"
import script from "./commerce.vue?vue&type=script&lang=ts&"
export * from "./commerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a48b21",
  null
  
)

export default component.exports